export const QUERY_KEYS_ACCOUNT = {
  WISHLIST: 'WISHLIST',
  INTEREST_DATA: 'INTEREST_DATA',
};
